/**
 * Check if a due date is today or earlier (overdue).
 */
export function isDueDateTodayOrEarlier(dueDate) {
  if (!dueDate) return false;
  const today = new Date();
  const due = new Date(dueDate);
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);
  return due < today;
}

/**
 * Format a date to YYYY-MM-DD for form date inputs.
 */
export function formatFormDate(inputDate) {
  const dateObject = new Date(inputDate);
  return dateObject.toISOString().split('T')[0];
}

/**
 * Format a due date for display (e.g. "January 15, 2025").
 * Returns null for invalid or zero-value dates.
 */
export function formatDueDate(dueDate) {
  if (!dueDate) return null;
  const date = new Date(dueDate);
  if (isNaN(date.getTime()) || date.getFullYear() <= 10) return null;
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/**
 * Get today's date as YYYY-MM-DD adjusted for timezone.
 */
export function getTodayISO() {
  const today = new Date();
  const adjusted = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
  return adjusted.toISOString().split('T')[0];
}
